<template>
  <div class="box">
    <div class="top">
      <div class="title">基金档案</div>
      <div @click="toLink" class="top-right">
        <div :maxFontZoomScale="1.0" class="text">更多基本信息</div>
        <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png" />
      </div>
    </div>
    <div class="date">
      <div :maxFontZoomScale="1.0" class="txt1">成立时间</div>
      <div :maxFontZoomScale="1.0" class="txt2">{{ setUpDate }}</div>
    </div>
    <div class="date">
      <div :maxFontZoomScale="1.0" class="txt1">产品额度</div>
      <div :maxFontZoomScale="1.0" class="txt2">{{
        highEndArchives.WHOLELIMIT
      }}</div>
    </div>
    <div class="line" />
    <!-- 现任经理 -->
    <div v-if="!isEmpty(highEndArchives.managerInfo)">
      <div
        class="item"
        v-for="(item, index) in highEndArchives.managerInfo"
        :key="index"
      >
        <div v-if="!isEmpty(item.managers)">
          <div :maxFontZoomScale="1.0" class="desc">{{ item.desc }}</div>
          <div v-for="(m, i) in item.managers" :key="`managers${i}`">
            <div class="name-row" @click="goDetail(m, item.desc)">
              <div :maxFontZoomScale="1.0" class="name">{{ m.name }}</div>
              <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png" />
            </div>
            <!-- 学历｜任职时间｜任职回报 -->
            <!-- 任期回报：涨红跌绿 -->
            <div
              class="manager-desc"
              v-html="getManagerDesc(m)"
            ></div>
            <div v-if="m.tags.length" class="tags">
              <div
                v-for="(tag, ind) in m.tags"
                :maxFontZoomScale="1.0"
                :style="{ marginRight: ind >= 0 ? '12wx' : '0' }"
                :key="`tag${ind}`"
                class="tag"
                >{{ tag }}</div
              >
            </div>
          </div>
          <high-end-rich-text v-if="item.content" :item="item" />
          <div
            v-if="index !== highEndArchives.managerInfo.length - 1"
            class="line"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HighEndRichText from '@/components/TextEllipsisExample.vue';
import tool from '@/utils/tool';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';

export default {
  components: { HighEndRichText },

  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
    mergeData: Object,
    anchorIndex: Number, // 锚点索引
  },

  computed: {
    // 高端基金档案
    highEndArchives() {
      return this.mergeData?.highEndArchives || {};
    },
    setUpDate() {
      if (this.elementData?.isNewFund) {
        return '等待成立';
      }
      return this.highEndArchives.setUpDate || '--';
    },
  },

  methods: {
    isEmpty,
    // 跳转到基金档案
    toLink() {
      this.$wxSendTrack('wxgdpzy.jcxx.gdjbxx.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      tool.goDetail(`fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcIndex/index?fundCode=${this.fundCode}&fundName=${this.highEndArchives.fundName}&index=0`, this.$goFundApp);
    },
    goDetail(m, desc) {
      if (desc === '管理人') {
        // 点击管理人
        this.goCompanyDetail(m);
      } else {
        // 点击基金经理
        this.goManagerDetail(m);
      }
    },
    getManagerDesc(m) {
      const { degree = '', serviceDays = '', yieldSince = '' } = m || {};
      const profit = isEmpty(yieldSince)
        ? '--'
        : `${numeral(yieldSince).format('0.00')}%`;
      const temp = [
        degree,
        !isEmpty(serviceDays) ? `任职时间:${serviceDays}` : '',
        !isEmpty(yieldSince) ? `任职回报:<span style="color: ${this.fontColor(yieldSince)};">${profit}</span>` : '',
      ];
      return (temp || []).filter((desc) => !isEmpty(desc)).join(' | ');
    },
    fontColor(value) {
      const num = parseFloat(value);
      if (num > 0) { return '#ff4400'; }
      if (num < 0) { return '#12B412'; }
      return '#000000';
    },
    getManagerAttributes(m) {
      const text = this.getManagerDesc(m);
      const profitPosition = text.indexOf('任职回报:');
      return [
        {
          range: {
            location: profitPosition + 5, // 开始位置
            length: text.length - (profitPosition + 5), // 长度
          },
          color: this.fontColor(m?.yieldSince), // 文字颜色
          fontSize: '24px',
        },
      ];
    },
    goManagerDetail(m) {
      if (!m.mgrId) {
        return;
      }
      if (multi.$system.webPlatform === 'wxmp') {
        const source = `fund://mp.1234567.com.cn/weex/fund8791fabebcf94b/pages/index?managerId=${m.mgrId}`;
        const convertUrl = tool.getJumpUrl(source);
        if (source === convertUrl) {
          this.$goFundApp();
          return;
        }
        wx.miniProgram.navigateTo({
          url: convertUrl,
        });
        return;
      }
      // 跳转基金经理页面
      // 参数比较长，用内存传参
      // 姓名、学历、从业年限、任期回报、简历
      multi.$storage.setMemory(`FundManger${m.mgrId}`, {
        name: m.name,
        degree: m.degree,
        workYears: m.workYears,
        yieldSince: m.yieldSince,
        resume: m.resume,
      });
      multi.$router.push({
        url: 'fund://mp.1234567.com.cn/weex/fund8791fabebcf94b/pages/index',
        type: 2,
        params: {
          managerId: m.mgrId,
        },
      });
    },
    goCompanyDetail(m) {
      if (multi.$system.webPlatform === 'wxmp') {
        const source = `fund://mp.1234567.com.cn/weex/0fd9c439912651715e2620af0357f0e5/pages/companyDetail/index?companyCode=${m.managerCode}&companycode=${m.managerCode}`;
        const convertUrl = tool.getJumpUrl(source);
        if (source === convertUrl) {
          this.$goFundApp();
          return;
        }
        wx.miniProgram.navigateTo({
          url: convertUrl,
        });
        return;
      }
      // 跳转至基金公司页面
      multi.$router.push({
        url: `fund://mp.1234567.com.cn/weex/0fd9c439912651715e2620af0357f0e5/pages/companyDetail/index?companyCode=${m.managerCode}&companycode=${m.managerCode}`,
        type: 2,
      });
    },
  },
};
</script>

<style scoped>

.box {
  margin-top: 24px;
  padding-bottom: 40px;
  border-radius: 16px;
  background-color: #ffffff;
}

.top {
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
}
.name-row {
  display: flex;
  margin-top: 24px;
  flex-direction: row;
  align-items: center;
}

.title {
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #000000;
  font-weight: bold;
}

.top-right {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  text-align: right;
}

.right-arrow {
  /* px2wx:change next */
  width: 32px;
  height: 32px;
  margin-left: 8px;
}

.date {
  margin-left: 24px;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.txt1 {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
}

.txt2 {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
  margin-left: 24px;
}

.line {
  margin: 24px 24px 40px;
  height: 1px;
  background-color: #eeeeee;
}

.desc {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
  margin-left: 24px;
}

.name {
  font-family: PingFangSC-Medium;
  font-size: 32px;
  color: #000000;
  text-align: justify;
  margin-left: 24px;
  font-weight: bold;
}
.manager-desc {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  line-height: 28px;
  margin: 16px 0 0 24px;
}

.tags {
  display: flex;
  flex-direction: row;
  margin-left: 24px;
  margin-right: 24px;
  flex-wrap: wrap;
}

.tag {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #666666;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 4px 8px 4px 8px;
  margin-top: 16px;
}
</style>
